"use strict";

var Seemple = require('./seemple')["default"];

var SeempleArray = require('./array')["default"];

var SeempleObject = require('./object')["default"];

Seemple.Object = SeempleObject;
Seemple.Array = SeempleArray;
module.exports = Seemple;
//# sourceMappingURL=index.js.map